const ADD_SUB_CATEGORY = "ADD_SUB_CATEGORY";
const UPDATE_SUB_CATEGORY = "ADD_SUB_CATEGORY";
const DELETE_SUB_CATEGORY = "DELETE_SUB_CATEGORY";
const SUB_CATEGORYS = "SUB_CATEGORYS";
const ADD_SUB_CATEGORY_ERROR = "ADD_SUB_CATEGORY_ERROR";
const SUB_CATEGORY_DETAILS = "SUB_CATEGORY_DETAILS";

export {
	ADD_SUB_CATEGORY,
	UPDATE_SUB_CATEGORY,
	DELETE_SUB_CATEGORY,
	SUB_CATEGORYS,
	ADD_SUB_CATEGORY_ERROR,
	SUB_CATEGORY_DETAILS,
};
